import { render, staticRenderFns } from "./gzdetail.vue?vue&type=template&id=0173aa02&scoped=true"
import script from "./gzdetail.vue?vue&type=script&lang=js"
export * from "./gzdetail.vue?vue&type=script&lang=js"
import style0 from "./gzdetail.vue?vue&type=style&index=0&id=0173aa02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0173aa02",
  null
  
)

export default component.exports